import { queryOptions } from '@tanstack/react-query';
import type { SourceChannelDto, SourceChannelKind } from '@upme/contracts';
import { api } from '../../app/api-client';

export const sourceChannelsKey = ['admin', 'source-channels'] as const;

export interface SourceChannelListFilters {
  cityId?: string;
  isActive?: boolean;
  kind?: SourceChannelKind;
}

function buildSearchParams(filters: SourceChannelListFilters): URLSearchParams {
  const params = new URLSearchParams();
  for (const [k, v] of Object.entries(filters)) {
    if (v === undefined || v === null || v === '') continue;
    params.set(k, String(v));
  }
  return params;
}

export const listSourceChannelsOptions = (filters: SourceChannelListFilters = {}) =>
  queryOptions({
    queryKey: [...sourceChannelsKey, 'list', filters] as const,
    queryFn: () =>
      api
        .get('admin/source-channels', { searchParams: buildSearchParams(filters) })
        .json<SourceChannelDto[]>(),
    staleTime: 10_000,
  });

export const sourceChannelByIdOptions = (id: string) =>
  queryOptions({
    queryKey: [...sourceChannelsKey, id] as const,
    queryFn: () => api.get(`admin/source-channels/${id}`).json<SourceChannelDto>(),
  });
